import React from 'react';
import './styles.css';
import { RoadmapIcon, RoadmapStat } from '../../../Components/Roadmap';

const Roadmap = () => (
  <section className="workshop_content_parent_container">
    <div className="workshop_content_child_container">
      <div className="roadmap_road">
        <div className="roadmap_road_line" />

        <div className="roadmap_road_icon_2">
          <RoadmapIcon name="fas fa-laptop-code" color="#1e0e91" />
        </div>

        <div className="roadmap_road_week_2">
          <RoadmapStat top="April" mid="16th" bot="Workshop" color="#1e0e91" />
        </div>

        <div className="roadmap_road_icon_3">
          <RoadmapIcon name="fas fa-laptop-code" color="#33B8D4" />
        </div>

        <div className="roadmap_road_week_3">
          <RoadmapStat top="April" mid="17th" bot="Workshop" color="#33B8D4" />
        </div>

        <div className="roadmap_road_icon_4">
          <RoadmapIcon name="fas fa-brain" color="#7B51D0" />
        </div>

        <div className="roadmap_road_week_4">
          <RoadmapStat top="April" mid="23rd" bot="Test" color="#7B51D0" />
        </div>

        <div className="roadmap_road_icon_5">
          <RoadmapIcon name="fas fa-poll" color="#FF9A4D" />
        </div>

        <div className="roadmap_road_week_5">
          <RoadmapStat top="April" mid="30th" bot="Results" color="#FF9A4D" />
        </div>

        <div className="roadmap_road_icon_6">
          <RoadmapIcon name="fas fa-crown" color="#C232AC" />
        </div>

        <div className="roadmap_road_week_6">
          <RoadmapStat
            top="May"
            mid="2nd"
            bot="Internship Starts for the top 10 Rank Holders"
            color="#C232AC"
          />
        </div>
      </div>
    </div>
  </section>
);

export default Roadmap;



// WEBPACK FOOTER //
// ./src/Pages/Workshop/Roadmap/index.js